import { Outlet } from 'react-router-dom'

function ReportHome() {
  return (
    <Outlet/>
  )
}

export default ReportHome
